export default __webpack_public_path__ + "static/media/lact.cfec5fdd.png";